import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { MessageData } from '../types';

export type MessageModalState = {
  showModal: boolean;
  messageData: MessageData
}

const initialState: MessageModalState = {
  showModal: false,
  messageData: {}
};

const messageModalSlice = createSlice({
  initialState,
  name: 'messageModal',
  reducers: {
    closeMsgModal: (state) => {
      state.showModal = false;
    },
    openMsgModal: (state, action: PayloadAction<MessageData>) => {
      state.messageData.title = action.payload.title;
      state.messageData.description = action.payload.description;
      state.messageData.image = action.payload.image;
      state.showModal = true;
    }
  }
});

const { actions, reducer } = messageModalSlice;

export const { openMsgModal, closeMsgModal } = actions;

export default reducer;
